import React from "react";
import { IoClose } from "react-icons/io5";
import { RotateCcw } from "lucide-react";
import "../styles/ColumnFilterSidebar.css";

const ColumnFilterSidebar = ({
  availableColumns = [],
  selectedColumns = [],
  setSelectedColumns,
  availableFilters = [],
  selectedFilters = [],
  setSelectedFilters,
  defaultColumns = [],
  defaultFilters = [],
  onClose,
  isOpen,
}) => {
  const allColumnsSelected = availableColumns.length > 0 && selectedColumns.length === availableColumns.length;
  const allFiltersSelected = availableFilters.length > 0 && selectedFilters.length === availableFilters.length;

  const handleSelectAllColumns = () => {
    if (allColumnsSelected) {
      setSelectedColumns([]);
    } else {
      setSelectedColumns(availableColumns.map(col => col.key));
    }
  };

  const handleSelectAllFilters = () => {
    if (allFiltersSelected) {
      setSelectedFilters([]);
    } else {
      setSelectedFilters(availableFilters.map(f => f.key));
    }
  };

  const handleResetDefault = () => {
    if (defaultColumns && defaultColumns.length > 0) {
      setSelectedColumns(defaultColumns);
    }
    if (defaultFilters && defaultFilters.length > 0) {
      setSelectedFilters(defaultFilters);
    }
  };

  const handleColumnChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedColumns([...selectedColumns, value]);
    } else {
      setSelectedColumns(selectedColumns.filter(col => col !== value));
    }
  };

  const handleFilterChange = (e) => {
    const { value, checked } = e.target;
    if (checked) {
      setSelectedFilters([...selectedFilters, value]);
    } else {
      setSelectedFilters(selectedFilters.filter(f => f !== value));
    }
  };

  return (
    <div className={`column-filter-sidebar-wrapper ${isOpen ? "open" : ""}`}>
      <div className="column-filter-sidebar-header">
        <h3>Manage Columns & Sidebar Filters</h3>
        <IoClose className="column-filter-sidebar-close-btn" onClick={onClose} />
      </div>

      <div className="column-filter-sidebar-body">
        <div className="column-filter-sidebar-section">
          <h4 className="column-filter-sidebar-section-title">Table Columns</h4>
          <label className="column-filter-sidebar-item" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '10px', marginBottom: '10px' }}>
            <input type="checkbox" checked={allColumnsSelected} onChange={handleSelectAllColumns} />
            <span style={{ fontWeight: 700, color: '#0f172a' }}>Select All</span>
          </label>
          {availableColumns.map((col) => (
            <label key={col.key} className="column-filter-sidebar-item">
              <input
                type="checkbox"
                value={col.key}
                checked={selectedColumns.includes(col.key)}
                onChange={handleColumnChange}
              />
              {col.label}
            </label>
          ))}
        </div>

        <div className="column-filter-sidebar-section" style={{ marginTop: '20px', borderTop: '1px solid #e2e8f0', paddingTop: '15px' }}>
          <h4 className="column-filter-sidebar-section-title">Sidebar Filters</h4>
          <label className="column-filter-sidebar-item" style={{ borderBottom: '1px solid #f1f5f9', paddingBottom: '10px', marginBottom: '10px' }}>
            <input type="checkbox" checked={allFiltersSelected} onChange={handleSelectAllFilters} />
            <span style={{ fontWeight: 700, color: '#0f172a' }}>Select All</span>
          </label>
          {availableFilters.map((f) => (
            <label key={f.key} className="column-filter-sidebar-item">
              <input
                type="checkbox"
                value={f.key}
                checked={selectedFilters.includes(f.key)}
                onChange={handleFilterChange}
              />
              {f.label}
            </label>
          ))}
        </div>
      </div>

      {/* Footer with Reset to Default & Live Counter */}
      <div className="column-filter-sidebar-footer">
        <button
          type="button"
          className="column-filter-reset-btn"
          onClick={handleResetDefault}
        >
          <RotateCcw size={13} /> Reset to Default
        </button>
        <span className="column-filter-count-text">
          {selectedColumns.length} / {availableColumns.length} visible
        </span>
      </div>
    </div>
  );
};

export default ColumnFilterSidebar;